// useInterval hook
import {useEffect, useRef} from 'react';

import {useLayoutEffectIsomorphic} from './useLayoutEffectIsomorphic';

export const useInterval = (callback: () => void, delay: number | null) => {
    const savedCallback = useRef(callback);

    useLayoutEffectIsomorphic(() => {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() => {
        // Don't schedule if no delay is specified.
        if (!delay && delay !== 0) {
            return;
        }

        const id = setInterval(() => savedCallback.current(), delay);

        return () => clearInterval(id);
    }, [delay]);
};
